@import "~rfs/scss";

.singleFillGraphWrapper {
  width: 100%;
  svg {
    overflow: visible;
  }
  text {
    @include font-size(16px);
  }

  .groupLabel {
    @include font-size(12px);
  }
}
